import React from "react";
const DefaultImg = "/default.jpg";

export const ImageWithFallback = ({
  src,
  alt = "",
  className,
  loading = "lazy",
  ...rest
}) => {
  const handleError = (e) => {
    if (e.currentTarget.src !== DefaultImg) {
      e.currentTarget.src = DefaultImg;
    }

    if (rest.onError) {
      rest.onError(e);
    }
  };

  return (
    <img
      src={src || DefaultImg}
      alt={alt}
      className={className}
      loading={loading}
      onError={handleError}
      {...rest}
    />
  );
};